import { alpha, Stack, Typography, useTheme } from '@mui/material'

import OFUSimulateStepAddConversationItem from '~/features/campaigns/components/ofuSimulateStepAddConversationItem'
import OFUSimulateStepConversationItem from '~/features/campaigns/components/ofuSimulateStepConversationItem'
import {
  ECampaignChannel,
  TOfuSimulateOutreach,
  TOfuSimulateMessage,
  TOfuSimulateContact,
  TCampaignCreatePayload,
} from '~/features/campaigns/models'
import { ESpeaker } from '~/features/inbox/models'
import rem from '~/utils/ui'

type TOfuSimulateStepConversationProps = {
  outreach: TOfuSimulateOutreach
  index: number
  handleUpdateOutreach: (outreach: TOfuSimulateOutreach, index: number) => void
  contact: TOfuSimulateContact
  campaign: TCampaignCreatePayload
  disableMessageSimulation?: boolean
}

export default function OFUSimulateStepConversation({
  outreach,
  index,
  handleUpdateOutreach,
  contact,
  campaign,
  disableMessageSimulation = false,
}: TOfuSimulateStepConversationProps) {
  const theme = useTheme()

  const handleAddMessage = (messages: TOfuSimulateMessage[]) => {
    const newMessages: TOfuSimulateMessage[] = messages.map((message) => ({
      role: message.role,
      content: message.content.trim(),
      date: message.date,
    }))

    const updatedOutreach: TOfuSimulateOutreach = {
      ...outreach,
      messages: [...(outreach.messages || []), ...newMessages],
    }

    handleUpdateOutreach(updatedOutreach, index)
  }

  const getOutreachConversationMessages = () => {
    const initialContent =
      outreach.channel === ECampaignChannel.phone
        ? (outreach.voicemailScript ?? '')
        : outreach.emailBody || outreach.callScript || outreach.textScript || ''
    return [
      {
        role: ESpeaker.assistant,
        content: initialContent,
      },
      ...(outreach?.messages || []),
    ]
  }

  return (
    <Stack
      gap={2}
      sx={{
        p: 2,
        borderRadius: rem(8),
        backgroundColor: alpha(theme.palette.info.main, 0.05),
        opacity: disableMessageSimulation ? 0.5 : 1,
        cursor: disableMessageSimulation ? 'not-allowed' : 'auto',
      }}
    >
      <Typography variant="h6" sx={{ fontSize: rem(16), fontWeight: 600 }}>
        Simulate replies:
      </Typography>

      {outreach.messages &&
        outreach.messages.length > 0 &&
        outreach.messages.map((message) => (
          <OFUSimulateStepConversationItem
            key={`message - ${message.role}-${message.content}`}
            message={message}
          />
        ))}

      <OFUSimulateStepAddConversationItem
        handleSave={handleAddMessage}
        messages={getOutreachConversationMessages()}
        channel={outreach.channel}
        contact={contact}
        campaign={campaign}
        disabled={disableMessageSimulation}
      />
    </Stack>
  )
}
